import tableDesignComponent from './tableDesignComponent.vue';
export default {
  data() {
    return {};
  },
  components: {
    tableDesignComponent
  }
};